import { createFileRoute } from '@tanstack/react-router';
import { getTitleContextSlice } from '@utils/breadcrumbsUtils';
import { CodeOwner } from '@utils/router.utils';

export const Route = createFileRoute('/_breadcrumbsLayout/$accountId/threats/settings/Incident-rules')({
  beforeLoad: () => getTitleContextSlice('Incident Rules'),
  staticData: {
    owner: CodeOwner.SWB,
  },
});
